import React from 'react';
// import './ArticleList.css'; // If you are using a separate CSS file

// Custom Article Component with styles applied
const ArticleListAlexNichole = () => {
  return (
    <div className="Alex-Nichol-article-wrapper">
      <article className="Alex-Nichol-article">
        <h1>Posts</h1>
        <ul className="article-list">
          <li>
            <a  className="article-text" href="https://blog.aqnichol.com/2024/11/29/honeycrisp-a-deep-learning-framework/">
              Honeycrisp: An Apple-First Deep Learning Framework
              <label className="article-date">(11/29/2024)</label>
            </a>
            <p className="article-text"> Honeycrisp: An Apple-First Deep Learning Framework.</p>
          </li>
          <li>
            <a href="https://blog.aqnichol.com/2024/01/01/vpn-tunneling-to-share-streaming-services/">
              Sharing Streaming Services Across Households
              <label className="article-date">(01/01/2024)</label>
            </a>
          </li>
          <li>
            <a href="https://blog.aqnichol.com/2023/05/20/representing-3d-models-as-decision-trees/">
              Representing 3D Models as Decision Trees
              <label className="article-date">(05/20/2023)</label>
            </a>
          </li>
          <li>
            <a href="https://blog.aqnichol.com/2022/12/31/large-scale-vehicle-classification/">
              Large-Scale Vehicle Classification
              <label className="article-date">(12/31/2022)</label>
            </a>
          </li>
          <li>
            <a href="/2021/04/12/data-and-machines/">
              Data and Machines
              <label className="article-date">(04/12/2021)</label>
            </a>
          </li>
          <li>
            <a href="https://blog.aqnichol.com/2020/03/04/vq-draw-a-new-generative-model/">
              VQ-DRAW: A New Generative Model
              <label className="article-date">(03/04/2020)</label>
            </a>
          </li>
          <li>
            <a href="https://blog.aqnichol.com/2020/01/18/research-didnt-pan-out/">
              Research Projects That Didn’t Pan Out
              <label className="article-date">(01/18/2020)</label>
            </a>
          </li>
          <li>
            <a href="https://blog.aqnichol.com/2019/07/24/competing-in-the-obstacle-tower-challenge/">
              Competing in the Obstacle Tower Challenge
              <label className="article-date">(07/24/2019)</label>
            </a>
          </li>
          <li>
            <a href="https://blog.aqnichol.com/2019/04/03/prierarchy-implicit-hierarchies/">
              Prierarchy: Implicit Hierarchies
              <label className="article-date">(04/03/2019)</label>
            </a>
          </li>
          <li>
            <a href="https://blog.aqnichol.com/2018/12/24/solving-murder-with-go/">
              Solving murder with Go
              <label className="article-date">(12/24/2018)</label>
            </a>
          </li>
          <li>
            <a href="https://blog.aqnichol.com/2017/12/23/what-i-dont-know/">
              What I Don’t Know
              <label className="article-date">(12/23/2017)</label>
            </a>
          </li>
          <li>
            <a href="https://blog.aqnichol.com/2017/10/31/adversarial-traintest-splits/">
              Adversarial Train/Test Splits
              <label className="article-date">(10/31/2017)</label>
            </a>
          </li>
          <li>
            <a href="https://blog.aqnichol.com/2017/08/30/decision-trees-as-rl-policies/">
              Decision Trees as RL Policies
              <label className="article-date">(08/30/2017)</label>
            </a>
          </li>
          <li>
            <a href="https://blog.aqnichol.com/2017/07/04/keeping-tabs-on-all-my-neural-networks/">
              Keeping Tabs On All My Neural Networks
              <label className="article-date">(07/04/2017)</label>
            </a>
          </li>
          <li>
            <a href="https://blog.aqnichol.com/2017/06/11/why-im-remaking-openai-universe/">
              Why I’m Remaking OpenAI Universe
              <label className="article-date">(06/11/2017)</label>
            </a>
          </li>
          <li>
            <a href="https://blog.aqnichol.com/2017/04/15/the-meta-learning-quest-part-1/">
              The Meta-Learning Quest: Part 1
              <label className="article-date">(04/15/2017)</label>
            </a>
          </li>
          <li>
            <a href="https://blog.aqnichol.com/2017/04/05/slice-aliasing/">
              Slice Aliasing Is Nicer Than You Realize
              <label className="article-date">(04/05/2017)</label>
            </a>
          </li>
          <li>
            <a href="https://blog.aqnichol.com/2017/03/08/the-bug-that-wasted-a-month-of-gpu-time/">
              The Bug That Wasted a Month of GPU Time
              <label className="article-date">(03/08/2017)</label>
            </a>
          </li>
          <li>
            <a href="https://blog.aqnichol.com/2017/03/01/random-fun-with-linear-svms/">
              Random Fun with Linear SVMs
              <label className="article-date">(03/01/2017)</label>
            </a>
          </li>
          <li>
            <a href="https://blog.aqnichol.com/2017/02/14/can-neural-networks-learn-to-spell/">
              Can Neural Networks Learn to Spell?
              <label className="article-date">(02/14/2017)</label>
            </a>
          </li>
          <li>
            <a href="https://blog.aqnichol.com/2017/02/12/ancient-philosophy-as-a-classification-problem/">
              Ancient Philosophy as a Classification Problem
              <label className="article-date">(02/12/2017)</label>
            </a>
          </li>
        </ul>
      </article>
    </div>
  );
};

export default ArticleListAlexNichole;
